module.exports = configuration;